import React, { Component } from 'react';
import { Tabs } from 'antd';
import { Route, Redirect } from 'react-router-dom';
import OverviewTab from './overview/overviewPage';
import GroupsPage from './groups/groupsPage';
import PastorsTab from './pastors/pastorsPage';
import RevivalEditPage from './../revivals/revivalEdit';

class ChurchProfile extends Component {
  onTabChange = (key) => this.props.history.push(key);
  tabPath = (name) => `${this.props.match.url}/${name}`;

  render() {
    return (
      <div className="card-container">
        <Route exact path={`${this.props.match.url}`} render={() => <Redirect to={`${this.tabPath('overview')}`} />} />

        <Tabs className="dashboard-main-tabs" type="card" animated={true}
              activeKey={`${this.props.location.pathname}`} onChange={this.onTabChange}>
          <Tabs.TabPane tab="Overview" key={`${this.tabPath('overview')}`}>
            <Route path={`${this.tabPath('overview')}`} render={() => <OverviewTab {...this.props} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Pastors" key={`${this.tabPath('pastors')}`}>
            <Route path={`${this.tabPath('pastors')}`} render={() => <PastorsTab {...this.props} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Groups" key={`${this.tabPath('groups')}`}>
            <Route path={`${this.tabPath('groups')}`} render={() => <GroupsPage {...this.props} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Event" key={`${this.tabPath('event')}`}>
            <Route path={`${this.tabPath('event')}`} render={() => <RevivalEditPage {...this.props} />} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}

export default ChurchProfile;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/churchProfile.js